import React, { ReactNode } from "react";

const PageBlock: React.FC<{ children?: ReactNode }> = ({ children }) => {
  return (
    <div className="bg-white p-8 rounded-xl w-full  gap-8 flex flex-col">
      {children}
    </div>
  );
};

export default PageBlock;
